import React, {useContext} from 'react'
import './Developer.css'

import {  LanguageContext } from '../../context';



const Developer = () => {
  
  const { language } = useContext(LanguageContext);
  
  return (
      <>
    <div className='developer-container tab-content clearfix' role='tabpanel'>
            <div  className='tab-pane active'>
            <section >
                    <h1>Developers</h1>
                    Thank you for your interest in the TLV Open Data.
                    The data for each dataset can be either:
                    <ul>
                      <li>Downloaded directly as an Excel or CSV file (where available) through the link in "Raw Data CSV" in the "Info" tab for that dataset</li>
                      <li>Accessed through the API link published on the "API" tab (where available) for that dataset
                        <br/>
                        Datasets with API can be filtered through the <a href={`/${language}?categoryF=&typeF=Api`}>home page</a> for the site, by checking the mark for "Type Info" as "API"
                      </li>
                    </ul>
                    If you did not find the repository you were looking for, we will be happy to hear from you! Please use the "write us" link at the <a href={`/${language}`}>home page</a>.
                    
             </section>
		    </div>
	    </div>
        </>
  )
}

export default Developer